jQuery(function ($) {

    $('.securite-police-open').on('click', function(){
        $('.securite-police').addClass('securite-police-active');
        $('.securite-route').removeClass('securite-route-active');
        $('.securite-video').removeClass('securite-video-active');
        $('.securite-velo').removeClass('securite-velo-active');
    })

    $('.securite-video-open').on('click', function(){
        $('.securite-video').addClass('securite-video-active');
        $('.securite-police').removeClass('securite-police-active');
        $('.securite-route').removeClass('securite-route-active');
        $('.securite-velo').removeClass('securite-velo-active');
    })

    $('.securite-route-open').on('click', function(){
        $('.securite-route').addClass('securite-route-active');
        $('.securite-police').removeClass('securite-police-active');
        $('.securite-video').removeClass('securite-video-active');
        $('.securite-velo').removeClass('securite-velo-active');
    })

    $('.securite-velo-open').on('click', function(){
        $('.securite-velo').addClass('securite-velo-active');
        $('.securite-police').removeClass('securite-police-active');
        $('.securite-video').removeClass('securite-video-active');
        $('.securite-route').removeClass('securite-route-active');
    })

    
    $('.regle-bruit-open').on('click', function(){
        $('.regle-bruit').addClass('regle-bruit-active');
        $('.regle-dechets').removeClass('regle-dechets-active');
        $('.regle-feu').removeClass('regle-feu-active');
        $('.regle-encombrement').removeClass('regle-encombrement-active');
    })

    $('.regle-feu-open').on('click', function(){
        $('.regle-feu').addClass('regle-feu-active');
        $('.regle-bruit').removeClass('regle-bruit-active');
        $('.regle-dechets').removeClass('regle-dechets-active');
        $('.regle-encombrement').removeClass('regle-encombrement-active');
    })

    $('.regle-dechets-open').on('click', function(){
        $('.regle-dechets').addClass('regle-dechets-active');
        $('.regle-bruit').removeClass('regle-bruit-active');
        $('.regle-feu').removeClass('regle-feu-active');
        $('.regle-encombrement').removeClass('regle-encombrement-active');
    })

    $('.regle-encombrement-open').on('click', function(){
        $('.regle-encombrement').addClass('regle-encombrement-active');
        $('.regle-bruit').removeClass('regle-bruit-active');
        $('.regle-feu').removeClass('regle-feu-active');
        $('.regle-dechets').removeClass('regle-dechets-active');
    })

})

function check_active(){

}